import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import {
  IChecklistCategory,
  IChecklistCategorySearch,
  IChecklistSubCategory,
  IChecklistSubCategorySearch,
} from '../interfaces/checklist-category';
import { BaseDataService } from './base.data.service';
import { Injectable } from '@angular/core';
import { Checklist } from '../interfaces/checklist/checklist';
import { ITaskStep, TaskStepDTO } from '../interfaces/task-info';
import { compare } from 'fast-json-patch';
import {
  JobScreenChecklistAddStepPhoto,
  SetChecklistStepCompleteRequest,
} from '../interfaces/screen-specific/job-screen';

@Injectable({
  providedIn: 'root',
})
export class ChecklistService extends BaseDataService {
  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  entityTitle: string = 'Category';

  public ChecklistCategoryName = [
    'Select Category',
    'New Vehicle Delivery',
    'Relocations',
    'Breakdown',
    'Accident',
    'SMR',
    'Defleeting / Disposal',
    'Customer C&D',
  ];

  getChecklistCategories(search?: IChecklistCategorySearch): Promise<IChecklistCategory[]> {
    const url = '/api/checklistCategories';

    let myObject = {};

    if (search != null) {
      myObject = JSON.parse(JSON.stringify(search));
    }

    let params = new HttpParams({ fromObject: myObject });

    console.log('PARAMS', params);

    return this.handleRequest<any[]>(
      this.http.get<IChecklistCategory[]>(url, { params: params }),
      this.handlersFactory.getForReadAll(),
    );
  }

  getChecklistCategorySubCategories(categoryId: number): Promise<IChecklistSubCategory[]> {
    const url = '/api/checklistCategory/' + categoryId + '/SubCategories';

    return this.handleRequest<any[]>(
      this.http.get<IChecklistSubCategory[]>(url),
      this.handlersFactory.getForReadAll(),
    );
  }

  getChecklistSubCategories(search: IChecklistSubCategorySearch): Promise<IChecklistSubCategory[]> {
    const url = '/api/checklistSubCategories';

    let params = this.constructHttpParams(search);

    return this.handleRequest<any[]>(
      this.http.get<IChecklistSubCategory[]>(url, { params: params }),
      this.handlersFactory.getForReadAll(),
    );
  }

  createChecklistCategory(dto: IChecklistCategory) {
    const url = '/api/checklistCategory';

    return this.handleRequest<any[]>(
      this.http.post<IChecklistCategory[]>(url, dto),
      this.handlersFactory.getForCreate(this.entityTitle),
    );
  }

  createChecklistSubCategory(dto: IChecklistSubCategory) {
    const url = '/api/checklistSubCategory';

    return this.handleRequest<any[]>(
      this.http.post<IChecklistSubCategory[]>(url, dto),
      this.handlersFactory.getForCreate(this.entityTitle),
    );
  }

  updateChecklistCategory(dto: IChecklistCategory) {
    const url = '/api/updateChecklistCategory';

    return this.handleRequest<any[]>(
      this.http.put<IChecklistCategory[]>(url, dto),
      this.handlersFactory.getForReadAll(),
    );
  }

  updateChecklistSubCategory(dto: IChecklistSubCategory) {
    const url = '/api/updateChecklistSubCategory';

    return this.handleRequest<any[]>(
      this.http.put<IChecklistSubCategory[]>(url, dto),
      this.handlersFactory.getForReadAll(),
    );
  }

  getMergedChecklistSteps(id: number) {
    const url = '/api/task/' + id + '/merged-task-steps';

    return this.handleRequest<any[]>(
      this.http.get<any[]>(url),
      this.handlersFactory.getForReadAll(),
    );
  }

  getChecklist(id: number) {
    const url = '/api/task/' + id + '/checklist';

    return this.handleRequest<Checklist>(
      this.http.get<Checklist>(url),
      this.handlersFactory.getForReadAll(),
    );
  }

  getTaskSteps(): Promise<TaskStepDTO[]> {
    const url = '/api/taskSteps';
    return this.http.get<TaskStepDTO[]>(url).toPromise();
  }

  patchTaskStep(taskStepId: number, after: {}, before = {}): Promise<ITaskStep> {
    const patch = compare(before, after);

    const url = '/api/taskStep/' + taskStepId;
    return this.http.patch<ITaskStep>(url, patch).toPromise();
  }

  completeTaskStep(taskId: any, stepId: any, dto: SetChecklistStepCompleteRequest) {
    const url = `/api/task/completetaskstep`;

    return this.http.post(url, dto).toPromise();
  }

  addStepPhoto(taskId: number, stepId: number, dto: JobScreenChecklistAddStepPhoto) {
    const url = '/api/task/' + taskId + '/step/' + stepId + '/photo';

    return this.http.put(url, dto).toPromise();
  }
}
